export class TooLargeResponseError extends Error {}
